import { render, staticRenderFns } from "./ActsTable.vue?vue&type=template&id=37aff587&scoped=true&"
import script from "./ActsTable.vue?vue&type=script&lang=ts&"
export * from "./ActsTable.vue?vue&type=script&lang=ts&"
import style0 from "./ActsTable.vue?vue&type=style&index=0&id=37aff587&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aff587",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
